export default __webpack_public_path__ + "static/media/16.19082a7c.jpg";